import styled from 'styled-components';

import { ProfileInfoAdapter as InnerProfileInfo } from '@xing-com/crate-entity-pages-common';
import { SkeletonProfileImage, SkeletonBody } from '@xing-com/skeleton';
import {
  scale110,
  scale130,
  spaceS,
  scale050,
  spaceXS,
  spaceXXS,
  scale160,
} from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';
import { Column } from '@xing-com/xing-grid';

export const Title = styled(BodyCopy)`
  margin-bottom: ${scale130};
`;

export const Container = styled(Column)`
  margin: 0 auto;
`;

export const List = styled.ul`
  margin: ${scale110} 0;
  padding-left: 0;
`;

export const ListItem = styled.li`
  display: block;
  width: 100%;
  margin-bottom: ${scale130};
`;

export const ProfileInfo = styled(InnerProfileInfo)`
  p {
    margin-bottom: 0;
  }

  & h2 {
    margin-bottom: 0;
  }

  & strong {
    margin-right: ${spaceS};
  }
`;

export const SkeletonContainer = styled.div`
  display: flex;
`;

export const SkeletonInfoWrapper = styled.div`
  display: flex;
  flex: 1;

  &:hover {
    text-decoration: none;
  }
`;

export const SkeletonUserInfo = styled.div`
  flex: 1;
`;

export const SkeletonLogoImageContainer = styled(SkeletonProfileImage)`
  display: inline-block;
  width: ${scale160};
  height: ${scale160};
  margin-right: ${scale050};

  & > div {
    height: 100%;
  }
`;

export const SkeletonTitleSkeleton = styled(SkeletonBody)`
  margin-bottom: ${spaceXXS};
`;

export const SkeletonBodySkeleton = styled(SkeletonBody)`
  width: 85%;

  & div:first-child {
    margin-bottom: ${spaceXS};
  }
`;
